module.exports = __webpack_public_path__ + "static/ent-content-677c857e9abf180d966678758ebab8e1.png";